import { render } from "./Unidades.vue?vue&type=template&id=3648964c&scoped=true"
import script from "./Unidades.vue?vue&type=script&lang=js"
export * from "./Unidades.vue?vue&type=script&lang=js"

import "./Unidades.vue?vue&type=style&index=0&id=3648964c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3648964c"]])

export default __exports__